import type {
  CardHeaderSlots as CardHeaderBaseSlots,
  CardHeaderBaseProps,
  CardHeaderBaseState,
} from '@fluentui/react-card';

/**
 * CardHeader component slots
 */
export type CardHeaderSlots = CardHeaderBaseSlots;

/**
 * CardHeader component props
 */
export type CardHeaderProps = CardHeaderBaseProps;

/**
 * CardHeader component state
 */
export type CardHeaderState = CardHeaderBaseState;
